import React, { useEffect, useRef, useState } from 'react'
import { BsFillGrid3X3GapFill } from 'react-icons/bs'
import { Title } from '../../../../Templates/Title'
import { Button, Card, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import { getAllButtonsAdmin } from '../../../API/Buttons/Buttons'
import { SingleButton } from '../../../API/Buttons/models'
import { Variants } from './Variants'
import { NewButtonModal } from './components/NewButtonModal'
import { FaRegCopy } from 'react-icons/fa'
import { getStaticIconName } from './utils/utils'
import { useStaticButtonsIcons } from './hooks/useStaticButtonsIcons'
import { PaymentScale } from './PaymentScale'
import { AdminUser } from '../../../API/AdminInfo/models'

export const Buttons = ({ adminInfo }: { adminInfo: AdminUser | null }) => {

  const variationsRef = useRef<HTMLDivElement | null>(null);
  const { iconsHandler } = useStaticButtonsIcons()


  // Modals
  const [showNewButtonModal, setShowNewButtonModal] = useState(false)
  const [showButtonInformation, setShowButtonInformation] = useState(false)

  // Variant.
  const [selectedButton, setSelectedButton] = useState<SingleButton | null>(null)

  // Buttons
  const [bienvenidaButtons, setBienvenidaButtons] = useState<SingleButton[]>([])
  const [infoButtons, setInfoButtons] = useState<SingleButton[]>([])
  const [premiosButtons, setPremiosButtons] = useState<SingleButton[]>([])
  const [fichasButtons, setFichasButtons] = useState<SingleButton[]>([])
  const [extrasButtons, setExtrasButtons] = useState<SingleButton[]>([])
  const [staticButtons, setStaticButtons] = useState<SingleButton[]>([])

  const handleFetchButtons = async () => {
    getAllButtonsAdmin().then((res: SingleButton[]) => {
      const bienvenidaButtons: SingleButton[] = [];
      const infoButtons: SingleButton[] = [];
      const premiosButtons: SingleButton[] = [];
      const fichasButtons: SingleButton[] = [];
      const extrasButtons: SingleButton[] = [];
      const staticButtons: SingleButton[] = [];

      res?.forEach((button: any) => {
        if (button.category === 'bienvenida') {
          bienvenidaButtons.push(button);
        } else if (button.category === 'info') {
          infoButtons.push(button);
        } else if (button.category === 'premios') {
          premiosButtons.push(button);
        } else if (button.category === 'fichas') {
          fichasButtons.push(button)
        } else if (button.category === 'extra') {
          extrasButtons.push(button)
        } else if (button.category === 'static_button') {
          const hasGestorURL = !!adminInfo?.gestorUrl

          // Filter static buttons that are not allowed to be used if there is no gestorURL
          const nonAllowedButtons = ['static_newplayerbyemail', 'static_newplayer']
          if (!hasGestorURL && nonAllowedButtons.includes(button.name)) {
            return
          }

          staticButtons.push(button)
        }
      });

      setBienvenidaButtons(bienvenidaButtons);
      setInfoButtons(infoButtons);
      setPremiosButtons(premiosButtons);
      setFichasButtons(fichasButtons);
      setExtrasButtons(extrasButtons);

      const filteredStatics = staticButtons.filter((button) => button.name !== 'static_history' && button.name !== 'static_first')
      setStaticButtons(filteredStatics)
    });
  }

  const handleShowButtonInformation = ({ button }: { button: SingleButton }) => {
    setSelectedButton(button)
    setShowButtonInformation(true)
  }

  useEffect(() => {
    if (showNewButtonModal === false && showButtonInformation === false) {
      handleFetchButtons()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showNewButtonModal, showButtonInformation])


  const subTitleStatics = 'Los botones de acción son botones que se pueden usar para realizar acciones en la plataforma. No se pueden editar, ni eliminar.'
  const subTitleCopyPaste = 'Los botones de copiar y pegar son botones que se utilizan para copiar y pegar mensajes.'

  const filteredStatics = ['static_newplayerbyemail', 'static_newplayer']
  const firstStaticSection = staticButtons.filter((button) => !filteredStatics.includes(button.name))
  const secondStaticSection = staticButtons.filter((button) => filteredStatics.includes(button.name))

  return (
    <div className='pb-5'>

      {showNewButtonModal &&
        <NewButtonModal
          show={showNewButtonModal}
          onHide={() => setShowNewButtonModal(false)}
          adminInfo={adminInfo}
        />}

      <div>
        {!showButtonInformation &&
          <div className='d-flex flex-column w-100 mt-4'>

            <Title title='Botones de Acciones' icon={<BsFillGrid3X3GapFill size={30} />} subtitle={subTitleStatics} />
            <div className='d-flex w-100 gap-3'>

              {firstStaticSection.length > 0 &&
                <div className='d-flex flex-column'>
                  <span className='text-secondary mb-2 text-sm'>Menu Principal</span>
                  <Card className='mb-2' style={{ width: 'fit-content' }}>
                    <Card.Body>

                      {
                        firstStaticSection?.map((button, index) =>
                        (
                          <React.Fragment key={index}>

                            <OverlayTrigger
                              placement="bottom"
                              overlay={<Tooltip>{getStaticIconName(button)}</Tooltip>}
                            >
                              <button
                                key={index}
                                className={`btn btn-sm text-primaryy my-1 m-1 ${selectedButton?.id === button.id ? 'bg-primaryy text-white py-1' : 'py-0'}`}
                                onClick={() => handleShowButtonInformation({ button })}
                              >
                                {iconsHandler({ button: button.name })}
                              </button>
                            </OverlayTrigger>
                          </React.Fragment>

                        ))
                      }
                    </Card.Body>

                  </Card>
                </div>
              }

              {secondStaticSection.length > 0 &&
                <div className='d-flex flex-column'>
                  <span className='text-secondary mb-2 text-sm'>Jugadores</span>
                  <Card className='mb-2' style={{ width: 'fit-content' }}>
                    <Card.Body>

                      {
                        secondStaticSection?.map((button, index) =>
                        (
                          <React.Fragment key={index}>

                            <OverlayTrigger
                              placement="bottom"
                              overlay={<Tooltip>{getStaticIconName(button)}</Tooltip>}
                            >
                              <button
                                key={index}
                                className={`btn btn-sm text-primaryy my-1 m-1 ${selectedButton?.id === button.id ? 'bg-primaryy text-white py-1' : 'py-0'}`}
                                onClick={() => handleShowButtonInformation({ button })}
                              >
                                {iconsHandler({ button: button.name })}
                              </button>
                            </OverlayTrigger>
                          </React.Fragment>

                        ))
                      }
                    </Card.Body>

                  </Card>
                </div>
              }
            </div>

            <div className='mt-4'>
              <Row className='d-flex align-items-center justify-content-between mb-2'>
                <Col md={10} sm={12}>
                  <Title title='Copiar y Pegar' icon={<FaRegCopy size={30} />} subtitle={subTitleCopyPaste} />
                </Col>
                <Col md={2} sm={12} className='d-flex justify-content-end'>
                  <Button variant='primary' onClick={() => setShowNewButtonModal(true)}>Nuevo Botón</Button>
                </Col>
              </Row>

              {bienvenidaButtons.length > 0 &&
                <Card className='mb-2'>
                  <Card.Body>
                    <div className='my-0 mx-0' style={{ display: 'flex', alignItems: 'center' }}>
                      <span className='text-secondary mb-2' style={{ fontSize: '10px' }}>Mensajes de Bienvenida</span>
                    </div>
                    {
                      bienvenidaButtons?.map((button, index) =>
                      (
                        <React.Fragment key={index}>
                          <button
                            key={index}
                            title={button.Messages[0]?.text}
                            className={`btn btn-sm btn-copypastes my-1 m-1 ${selectedButton?.id === button.id ? 'bg-primaryy text-white py-1' : 'py-0'}`}
                            onClick={() => handleShowButtonInformation({ button })}
                          >{button.name}
                          </button>
                        </React.Fragment>

                      ))
                    }
                  </Card.Body>
                </Card>
              }

              {infoButtons.length > 0 &&
                <Card className='mb-2'>
                  <Card.Body>
                    <div className='my-0 mx-0' style={{ display: 'flex', alignItems: 'center' }}>
                      <span className='text-secondary mb-2' style={{ fontSize: '10px' }}>Mensajes de Información</span>
                    </div>
                    {
                      infoButtons?.map((button, index) =>
                      (<React.Fragment key={index}>
                        <button
                          key={index}
                          title={button.Messages[0]?.text}
                          className={`btn btn-sm btn-copypastes my-1 m-1 ${selectedButton?.id === button.id ? 'bg-primaryy text-white py-1' : 'py-0'}`}
                          onClick={() => handleShowButtonInformation({ button })}
                        >{button.name}
                        </button>
                      </React.Fragment>

                      ))
                    }
                  </Card.Body>
                </Card>

              }


              {premiosButtons.length > 0 &&
                <Card className='mb-2'>
                  <Card.Body>
                    <div className='my-0 mx-0' style={{ display: 'flex', alignItems: 'center' }}>
                      <span className='text-secondary mb-2' style={{ fontSize: '10px' }}>Mensajes de Premios</span>
                    </div>
                    {
                      premiosButtons?.map((button, index) =>
                      (<React.Fragment key={index}>
                        <button
                          key={index}
                          title={button.Messages[0]?.text}
                          className={`btn btn-sm btn-copypastes my-1 m-1 ${selectedButton?.id === button.id ? 'bg-primaryy text-white py-1' : 'py-0'}`}
                          onClick={() => handleShowButtonInformation({ button })}
                        >{button.name}
                        </button>

                      </React.Fragment>
                      ))
                    }
                  </Card.Body>
                </Card>
              }

              {fichasButtons.length > 0 &&
                <Card className='mb-2'>
                  <Card.Body>
                    <div className='my-0 mx-0' style={{ display: 'flex', alignItems: 'center' }}>
                      <span className='text-secondary mb-2' style={{ fontSize: '10px' }}>Mensajes de Fichas</span>
                    </div>
                    {
                      fichasButtons?.map((button, index) =>
                      (<React.Fragment key={index}>
                        <button
                          key={index}
                          title={button.Messages[0]?.text}
                          className={`btn btn-sm btn-copypastes my-1 m-1 ${selectedButton?.id === button.id ? 'bg-primaryy text-white py-1' : 'py-0'}`}
                          onClick={() => handleShowButtonInformation({ button })}
                        >{button.name}
                        </button>
                      </React.Fragment>

                      ))
                    }


                  </Card.Body>
                </Card>
              }

              {extrasButtons.length > 0 &&
                <Card className='mb-2'>
                  <Card.Body>
                    <div className='my-0 mx-0' style={{ display: 'flex', alignItems: 'center' }}>
                      <span className='text-secondary mb-2' style={{ fontSize: '10px' }}>Mensajes Extras</span>
                    </div>
                    {
                      extrasButtons?.map((button, index) =>
                      (<React.Fragment key={index}>
                        <button
                          key={index}
                          title={button.Messages[0]?.text}
                          className={`btn btn-sm btn-copypastes my-1 m-1 ${selectedButton?.id === button.id ? 'bg-primaryy text-white py-1' : 'py-0'}`}
                          onClick={() => handleShowButtonInformation({ button })}
                        >{button.name}
                        </button>
                      </React.Fragment>

                      ))
                    }
                  </Card.Body>

                </Card>
              }
            </div>
          </div>
        }
      </div>

      {!showButtonInformation && <div className='mt-4'>
        <PaymentScale />
      </div>}



      {showButtonInformation &&
        <div ref={variationsRef}>
          <Variants selectedButton={selectedButton} adminInfo={adminInfo} setShowButtonInformation={setShowButtonInformation} setSelectedButton={setSelectedButton} />
        </div>
      }

    </div >


  )
}
